import { observable, decorate, action } from 'mobx';

import services from '../utils/ServiceUtils';
import * as Endpoints from '../utils/Endpoints';
import * as ErrorsUtils from '../utils/ErrorsUtils';
import * as ProductosConstants from '../utils/ProductosConstants';
import {
  ERROR_INTERNO_SERVICIO,
  ERROR_SERVICIO_FIRMA, ERROR_SERVICIO_FIRMA_ALMACENAR_DOC_BIOFIRMA,
  ERROR_SERVICIO_FIRMA_ID_INVALIDO_VIMP,
  ERROR_SERVICIO_FIRMA_ID_NOT_FOUND_VIMP,
  ERROR_SERVICIO_FIRMA_PARAMETROS, ERROR_SERVICIO_FIRMA_PIN_INVALIDO_VIMP,
  showErrorFirma,
  showErrorFirmaPin
} from '../utils/ErrorsUtils';

const MONEDA_PESOS = 'Pesos';
const SI = 'SI';
const FAMILIA_CUENTAS = 2;
class SolicitarNuevaPortalidadStore {
  cmbBancos = [];
  cmbFamilasProductos = [];
  listadoProductos = [];
  bancoSeleccionado = {};
  compromisoNoAmentarDeuda = 'N/A';
  bolsaProductos = [];
  compromisoDeuda = {};
  productosContratar = null;
  solicitudId = null;

  constructor(appstore) {
    this.appstore = appstore;
  }

  clearStore = () => {
    this.bancoSeleccionado = {};
    this.compromisoNoAmentarDeuda = 'N/A';
    this.bolsaProductos = [];
    this.compromisoDeuda = {};
    this.productosContratar = null;
    this.solicitudId = null;
  };

  cargarBancos = (onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Cargando listado de entidad financieras');
    }, 500);
    services
      .get(Endpoints.BANCOS_ENDPOINT + '?vigente=true')
      .then(
        action('cargarBancosOK', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          let datosBancos = [];
          response.data.forEach((banco) => {
            if (banco.id !== 8) {
              datosBancos.push({ id: banco.id, value: banco.id, nombre: banco.nombre, label: banco.nombre });
            }
          });
          this.cmbBancos = datosBancos;
          if (onResult) {
            onResult();
          }
        })
      )
      .catch(
        action('cargarBancosFail', (err) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          const response = err.response;
          if (response.status) {
            if (response.status === 500) {
              ErrorsUtils.showErrorFor(-99999);
            } else if (response.status === 400) {
              ErrorsUtils.showErrorFor(-99999);
            }
          }
          if (onFail) {
            onFail();
          }
        })
      );
  };

  productoEsFamilia = (producto) => {
    let result = false;
    const familia = this.cmbFamilasProductos.find((item) => {
      return item.nemo === producto.codProducto;
    });
    if (familia) {
      result = true;
    }
    return result;
  };

  agregarProducto = (producto) => {
    if (producto.codProducto === ProductosConstants.TODOS_LOS_PRODUCTOS) {
      this.limpiarBolsa();
    } else if (this.productoEsFamilia(producto)) {
      this.eliminarProductosFamilia(producto.codProducto);
    }
    const tipoProducto = this.buscarProductoPorNemo(producto.codProducto);
    producto.id = tipoProducto.id;
    producto.familiaProductoId = tipoProducto.familiaProductoId;
    producto.nemo = tipoProducto.nemo;
    this.bolsaProductos.push(producto);
  };

  buscarProductoPorNemo = (nemo) => {
    return this.listadoProductos.find((item) => {
      return item.value === nemo;
    });
  };

  buscarFamiliaEnBolsaPorNemo = (nemo) => {
    return this.bolsaProductos.find((item) => {
      return nemo === item.nemo;
    });
  };

  limpiarBolsa = () => {
    this.bolsaProductos = [];
  };

  eliminarFamilia = (tipoFamilia) => {
    this.bolsaProductos = this.bolsaProductos.filter((item) => {
      return item.codProducto !== tipoFamilia;
    });
  };

  eliminarProductosFamilia = (nemoFamilia) => {
    const familia = this.buscarFamiliaPorNemo(nemoFamilia);
    this.bolsaProductos = this.bolsaProductos.filter((item) => {
      return item.familiaProductoId !== familia.id;
    });
  };

  seleccionarBanco = (banco) => {
    this.bancoSeleccionado = banco;
  };

  comprometerDeuda(value) {
    this.compromisoNoAmentarDeuda = value;
  }

  portaTodosSusProductos = () => {
    return this.bolsaProductos.find((item) => {
      return item.codProducto === ProductosConstants.TODOS_LOS_PRODUCTOS;
    });
  };

  familiaSeleccionada = (tipoFamilia) => {
    let result = false;
    const found = this.bolsaProductos.find((item) => {
      return item.codProducto === tipoFamilia;
    });
    if (found) {
      result = true;
    }
    return result;
  };

  listarProductosPorIdFamilia = (idFamilia) => {
    return this.listadoProductos.filter((item) => {
      return item.familiaProductoId === idFamilia;
    });
  };

  buscarFamiliaPorNemo = (nemo) => {
    return this.cmbFamilasProductos.find((item) => {
      return item.value === nemo;
    });
  };

  listarProductosPorNemoFamilia = (nemoFamilia) => {
    let result = [];
    const familia = this.buscarFamiliaPorNemo(nemoFamilia);
    if (familia) {
      result = this.listarProductosPorIdFamilia(familia.id);
      if (result) {
        result = result.filter((item) => {
          return item.value !== nemoFamilia;
        });
        result = result.map((item) => {
          if (item.nemo === 'CTAPRE') {
            let temp = item;
            temp.label = temp.label + ' (Ej: MACH)';
            return temp;
          } else {
            return item;
          }
        });
      }
    }
    return result;
  };

  cargarFamiliasProductos = () => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Cargando Familias de Productos');
    }, 500);
    services
      .get(Endpoints.FAMILIAS_PRODUCTOS_ENDPOINT)
      .then(
        action('familiasProductosOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          this.cmbFamilasProductos = response.data.map((item) => {
            return { id: item.id, value: item.nemo, nemo: item.nemo, nombre: item.nombre, label: item.nombre };
          });
        })
      )
      .catch(
        action('familiasProductosFail', (err) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          const response = err.response;
          if (response.status) {
            if (response.status === 500) {
              ErrorsUtils.showErrorFor(-99999);
            } else if (response.status === 400) {
              ErrorsUtils.showErrorFor(-9999);
            }
          }
        })
      );
  };

  cargarProductos = () => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Cargando listado de productos disponibles');
    }, 500);
    services
      .get(Endpoints.PRODUCTOS_ENDPOINT)
      .then(
        action('productosOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          let datosProductos = [];
          response.data.forEach((item) => {
            if(item.nemo!=='CTAAHO'){
              datosProductos.push({ id: item.id, nemo: item.nemo, value: item.nemo, label: item.nombre, nombre: item.nombre, familiaProductoId: item.familiaProductoId });
            }
          });
          this.listadoProductos = datosProductos;
        })
      )
      .catch(
        action('ProductosFail', (err) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          const response = err.response;
          if (response.status) {
            if (response.status === 500) {
              ErrorsUtils.showErrorFor(-99999);
            } else if (response.status === 400) {
              ErrorsUtils.showErrorFor(-999999);
            }
          }
        })
      );
  };

  tieneCompromisoDeuda = () => {
    let result = false;
    const producto = this.bolsaProductos.find((item) => {
      return item.nemo === ProductosConstants.TODOS_LOS_PRODUCTOS || item.nemo === ProductosConstants.FAMILIA_ROTATIVOS;
    });
    if (producto) {
      result = producto.compromisoDeuda;
    }
    return result;
  };

  buildListadoProductosSolicitud = () => {
    let productos = this.bolsaProductos.map((item) => {
      let moneda = MONEDA_PESOS;
      if (item.familiaProductoId === FAMILIA_CUENTAS && item.moneda) {
        moneda = this.appstore.findMoneda(item.moneda);
      }
      return {
        productoId: item.id,
        moneda: moneda,
        montoMaximoDeuda: this.getValueOrNull(item.montoMaximoDeuda),
        identificador: item.numeroCuenta,
        montoAprobado: this.getValueOrNull(item.montoAprobado),
        montoAdeudado: this.getValueOrNull(item.montoDeuda),
        vigenciaCredito: this.getValueOrNull(item.vigencia),
        familiaId: item.familiaProductoId,
      };
    });
    const productosTodos = this.buscarFamiliaEnBolsaPorNemo(ProductosConstants.TODOS_LOS_PRODUCTOS);
    const productosRotativos = this.buscarFamiliaEnBolsaPorNemo(ProductosConstants.FAMILIA_ROTATIVOS);
    let compromiso;
    if (productosTodos) {
      compromiso = productosTodos.compromisoDeuda;
    } else if (productosRotativos) {
      compromiso = productosRotativos.compromisoDeuda;
    }
    if (compromiso) {
      let nuevosProductos;
      if (compromiso.lineas) {
        nuevosProductos = this.buildProductoFromCompromiso(compromiso.lineas, ProductosConstants.TIPO_LINEA_CREDITO);
        if (nuevosProductos) {
          productos = productos.concat(nuevosProductos);
        }
      }
      if (compromiso.tarjetas) {
        nuevosProductos = this.buildProductoFromCompromiso(compromiso.tarjetas, ProductosConstants.TIPO_TARJETA_CREDITO);
        if (nuevosProductos) {
          productos = productos.concat(nuevosProductos);
        }
      }
    }
    return productos;
  };

  buildProductoFromCompromiso = (datos, tipo) => {
    let productos;
    if (datos.tieneProducto === SI && datos.compromisoProductos === SI) {
      let tipoProducto = this.buscarProductoPorNemo(tipo);
      if (tipoProducto) {
        const montos = datos.montosProductos.filter((item) => {
          return item;
        });
        productos = montos.map((item) => {
          return {
            productoId: tipoProducto.id,
            moneda: MONEDA_PESOS,
            montoMaximoDeuda: this.getValueOrNull(item),
            familiaId: tipoProducto.familiaProductoId,
            compromisoDeuda: true,
          };
        });
      }
    }
    return productos;
  };

  getValueOrNull(value) {
    let result = null;
    if (value) {
      result = value;
    }
    return result;
  }

  buildProductosContratar = (productosContratar) => {
    let result = {
      ctaCteSel: false,
      ctaVisSel: false,
      ctaAhoSel: false,
      ctaPreSel: false,
      linCreSel: false,
      tarCreSel: false,
      creConSel: false,
      creComSel: false,
      creHipSel: false,
      creAutSel: false,
      creOtrSel: false,
      otrOtrSel: false,
      montoCredito: null,
      plazo: null,
      objetivoDeuda: false,
    };
    if (productosContratar) {
      result.tarCreSel = productosContratar.tarjetaSeleccionada;
      result.creConSel = productosContratar.creditoSeleccionado;
      result.ctaVisSel = productosContratar.cuentaVistaSeleccionada;
      result.ctaCteSel = productosContratar.cuentaCorrienteSeleccionada;
      result.objetivoDeuda = productosContratar.objetivoDeuda === SI;
      result.montoCredito = productosContratar.montoCredito;
      result.plazo = productosContratar.plazo;
    }
    return result;
  };

  crearSolicitud = (onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Cargando listado de productos disponibles');
    }, 500);
    services
      .post(Endpoints.SOLICITUD_ENDPOINT, {
        bancoId: this.bancoSeleccionado.id,
        compromiso: false,
        solicitudProductos: this.buildListadoProductosSolicitud(),
        productosContratar: this.buildProductosContratar(this.productosContratar),
      })
      .then(
        action('crearSolicitudOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          this.solicitudId = response.data.solicitudId;
          if (onResult) {
            onResult(response.data);
          }
        })
      )
      .catch(
        action('crearSolicitudFail', (err) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          const response = err.response;
          if (response.status) {
            if (response.status === 500) {
              ErrorsUtils.showErrorFor(response.data.resultCode);
            } else if (response.status === 400) {
              ErrorsUtils.showErrorFor(response.data.resultCode);
            } else if (response.status === 401) {
              ErrorsUtils.showSessionInvalida();
            }
          } else {
            ErrorsUtils.errorGenerico();
          }
          if (onFail) {
            onFail();
          }
        })
      );
  };

  generarCertificado = (clienteId, onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Generando certificado');
    }, 500);
    services
      .post(Endpoints.GENERAR_CERTIFICADO_ENDPOINT + '/preview', {
        bancoId: this.bancoSeleccionado.id,
        compromiso: false,
        solicitudProductos: this.buildListadoProductosSolicitud(),
        productosContratar: this.buildProductosContratar(this.productosContratar),
      })
      .then(
        action('generarCertificadOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          if (response.data.resultCode === 0) {
            if (onResult) {
              onResult(response.data.pdf);
            }
          } else {
            ErrorsUtils.showErrorFor(-99999);
          }
        })
      )
      .catch(
        action('generarCertificadoFail', (err) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          const response = err.response;
          if (response.status && response.status) {
            if (response.status === 401) {
              ErrorsUtils.showSessionInvalida();
            } else {
              ErrorsUtils.showErrorFor(-99999);
            }
          } else {
            ErrorsUtils.showErrorFor(-99999);
          }
          if (onFail) {
            onFail();
          }
        })
      );
  };


  firmarCertificado = (idChallenge, pin, onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Generando tu solicitud');
    }, 500);
    services
      .post(Endpoints.SOLICITUD_ENDPOINT + '/' + this.solicitudId + '/firmar', {
        rutCliente: this.appstore.rutCliente,
        pin: pin,
        idChallenge: idChallenge,
      })
      .then(
        action('generarCertificadOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          if (onResult) {
            this.idDocumentoSinacofi = response.data.idDocumento;
            onResult(response.data);
          }
        })
      )
      .catch(
        action('generarCertificadoFail', (err) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          const response = err.response;
          if (response.status) {
            if (response.status === 500) {
              switch (err.response.resultCode) {
                case ERROR_INTERNO_SERVICIO:
                case ERROR_SERVICIO_FIRMA:
                case ERROR_SERVICIO_FIRMA_ID_NOT_FOUND_VIMP:
                case ERROR_SERVICIO_FIRMA_ID_INVALIDO_VIMP:
                case ERROR_SERVICIO_FIRMA_PARAMETROS:
                case ERROR_SERVICIO_FIRMA_ALMACENAR_DOC_BIOFIRMA:
                  showErrorFirma(this.solicitudId);
                  break;
                case ERROR_SERVICIO_FIRMA_PIN_INVALIDO_VIMP:
                  showErrorFirmaPin(this.appstore.state.datosCliente.celular);
                  break;
                default:
                  ErrorsUtils.showErrorFor(err.response.resultCode);
              }
            } else if (response.status === 400) {
              ErrorsUtils.showErrorFor(err.response.resultCode);
            } else if (response.status === 401 || response.status === 403) {
              ErrorsUtils.showSessionInvalida();
            }
          } else {
            ErrorsUtils.showErrorFor(-99999);
          }
          if (onFail) {
            onFail();
          }
        })
      );
  };

  generarCertificadoPorId = (solicitudId, onResult, onFail) => {
    let timer = setTimeout(() => {
      this.appstore.showLoading('Generando certificado');
    }, 500);
    services
      .get(Endpoints.GENERAR_CERTIFICADO_ENDPOINT + '/' + solicitudId)
      .then(
        action('generarCertificadPorIdOk', (response) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          if (response.status===200) {
            if (onResult) {
              onResult(response.data.documento);
            }
          } else {
            ErrorsUtils.showErrorFor(-99999);
          }
        })
      )
      .catch(
        action('generarCertificadoPorIdFail', (err) => {
          clearTimeout(timer);
          this.appstore.hideLoading();
          const response = err.response;
          if (response.status) {
            if (response.status === 500) {
              ErrorsUtils.showErrorFor(-99999);
            } else if (response.status === 400) {
              ErrorsUtils.showErrorFor(-99999);
            } else if (response.status === 401) {
              ErrorsUtils.showSessionInvalida();
            }
          } else {
            ErrorsUtils.showErrorFor(-99999);
          }
          if (onFail) {
            onFail();
          }
        })
      );
  };

  crearYFirmar = (pin, idChallenge, onResult, onFail) => {
    if (this.solicitudId) {
      this.firmarCertificado(idChallenge, pin, onResult, onFail);
    } else {
      this.crearSolicitud((data) => {
        this.firmarCertificado(idChallenge, pin, onResult, onFail);
      }, onFail);
    }
  };
}

decorate(SolicitarNuevaPortalidadStore, {
  cmbBancos: observable,
  cargarBancos: action,
  removeFamiliaSeleccionada: action,
  addFamiliaSeleccionada: action,
  bancoSeleccionado: observable,
  seleccionarBanco: action,
  agregarProducto: action,
  bolsaProductos: observable,
  compromisoNoAmentarDeuda: observable,
  comprometerDeuda: action,
  limpiarBolsa: action,
  cargarFamiliasProductos: action,
  listadoProductos: observable,
  cargarProductos: action,
});
export default SolicitarNuevaPortalidadStore;
